var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPinPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "OriginIconSelectedSVG",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "pin_pickup") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1x78562"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25B7FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1080FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pin_pickup",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(6.060606, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0266299,40.8783784 C22.2543618,40.8783784 25.1423324,39.527027 25.4820937,40.2027027 C25.7086012,40.6531532 23.5567799,43.9189189 19.0266299,50 C14.49648,43.9189189 12.3446587,40.6531532 12.5711662,40.2027027 C12.9109275,39.527027 15.7988981,40.8783784 19.0266299,40.8783784 Z M18.6868687,0 C29.0073413,0 37.3737374,8.31903337 37.3737374,18.5810811 C37.3737374,28.8431288 29.0073413,37.1621622 18.6868687,37.1621622 C8.36639609,37.1621622 3.97903932e-13,28.8431288 3.97903932e-13,18.5810811 C3.97903932e-13,8.31903337 8.36639609,0 18.6868687,0 Z",
    id: "Combined-Shape",
    fill: "url(#linearGradient-1x78562)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#FFFFFF",
    cx: 19.1919192,
    cy: 18.6868687,
    r: 7.07070707
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinPickup);
export default __webpack_public_path__ + "static/media/pin_pickup.3f90c9b3.svg";
export { ForwardRef as ReactComponent };